export const propertiesTableHead = ['title', 'address', 'created_at', 'property_manager', 'action']
